// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickemSettingsUpdateBody = {
  poolId: string;
  settings: {
    scoringFormat: "standard" | "confidence";
    picksRequiredMode: "all" | "count";
    picksRequiredCount?: number | null;
    pickBasis: "moneyline" | "spread";
    tiebreaker: "none" | "totalPoints";
    tiePolicy: "tieIsWin" | "tieIsLoss" | "tieIsVoid";
    winPoints: number;
    lossPoints: number;
    roundGrouping: "day" | "week";
    weekStartDay?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    endDateMode: "date" | "tbd";
  };
};

export type typePickemSettingsUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestConfigId: string;
    revision: number;
    effectiveFromRoundLabel: string | null;
    rulesLines: string[];
  };
};

export type typePickemSettingsUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemSettingsUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemSettingsUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickemSettingsUpdateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    settings: {
      type: "object",
      properties: {
        scoringFormat: { type: "string", enum: ["standard", "confidence"] },
        picksRequiredMode: { type: "string", enum: ["all", "count"] },
        picksRequiredCount: { oneOf: [{ type: "integer" }, { enum: [null] }] },
        pickBasis: { type: "string", enum: ["moneyline", "spread"] },
        tiebreaker: { type: "string", enum: ["none", "totalPoints"] },
        tiePolicy: {
          type: "string",
          enum: ["tieIsWin", "tieIsLoss", "tieIsVoid"],
        },
        winPoints: { type: "integer" },
        lossPoints: { type: "integer" },
        roundGrouping: { type: "string", enum: ["day", "week"] },
        weekStartDay: { oneOf: [{ type: "integer" }, { enum: [null] }] },
        startDate: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        endDate: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        endDateMode: { type: "string", enum: ["date", "tbd"] },
      },
      required: [
        "scoringFormat",
        "picksRequiredMode",
        "pickBasis",
        "tiebreaker",
        "tiePolicy",
        "winPoints",
        "lossPoints",
        "roundGrouping",
        "endDateMode",
      ],
    },
  },
  required: ["poolId", "settings"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickemSettingsUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickemSettingsUpdateBody);
  }

  return async function postPickemSettingsUpdate(
    payload: typePickemSettingsUpdateBody,
  ): Promise<
    typePickemSettingsUpdateOutput200 | typePickemSettingsUpdateOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickemSettingsUpdate" failed before calling the network. #4e1ef66553b3`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#4e1ef66553b3" },
        },
        data: null,
      } as typePickemSettingsUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pickem/settings-update`,
      httpMethod: "POST",
      options,
    })) as
      typePickemSettingsUpdateOutput200 | typePickemSettingsUpdateOutput400;
  };
}
